window.waitForLayer = function () {
  return new Promise(function (resolve) {
    (function pollForLayer() {
      if (window.Useful) resolve(window.Useful);
      setTimeout(pollForLayer, 10);
    })();
  });
};

/*
(function () {
  const current_script = document.currentScript;
  let asset_path_url = current_script
    .getAttribute("src")
    .split("(ulayer).js")[0];

  const script = document.createElement("script");
  script.setAttribute("defer", true);
  script.setAttribute("type", "module");
  script.setAttribute(
    "src",
   `http://localhost:1337/main.ts` || `${asset_path_url}(useful).js`
  );

  document.head.append(script);
})();
*/